import { PARALLAX, gangstaverseText } from "@constants/images";
import {
  ParallaxBanner,
  ParallaxBannerLayer,
  ParallaxProvider,
} from "react-scroll-parallax";
import { Parallax, ParallaxLayer } from "@react-spring/parallax";
import Button from "@components/common/Button.component";
import { useNavigate } from "react-router-dom";

const Component = () => {
  const navigate = useNavigate();

  return (
    <ParallaxBanner
      layers={[
        { image: PARALLAX.LAYER1, speed: -20, className: "layer-one" },
        { image: PARALLAX.LAYER2, speed: -25, className: "layer-two" },
        { image: PARALLAX.LAYER3, speed: -10, className: "layer-three" },
        { image: PARALLAX.LAYER4, speed: -10, className: "layer-four" },
        { image: PARALLAX.LAYER5, speed: -10, className: "layer-five" },
      ]}
      className="aspect"
    >
      <div className="banner-text ">
        <h1
          data-wow-duration="3s"
          className="banner-heading wow animate__animated animate__fadeIn"
        >
          Welcome to <br />
          <img
            className="gangstaverse-text"
            src={gangstaverseText}
            alt="gangstaverseText"
          />
          <br/>
          <button onClick={() => navigate("/mint")}className="btn" style={{"width":"320px"}}>
          <p>RESERVE AN ILLUSTRATION</p>
        </button>
        </h1>
        {/* <p
          className="banner-desc wow animate__animated animate__fadeIn"
          data-wow-delay="1s"
        >
          Experience an Immersive Web3 Genre of NFT and Gaming.
        </p> */}
      </div>
    </ParallaxBanner>
  );
};

const GangstaverseInfo = () => {
  return (
    // <div className="gangstaverse-info-bg">
    //   <motion.div
    //     initial={{ opacity: 0, scale: 0.5 }}
    //     animate={{ opacity: 1, scale: 1 }}
    //     transition={{ duration: 0.7 }}
    //     className="gangstaverse-info-wrapper"
    //   >
    <>
      <ParallaxProvider>
        <Component />
      </ParallaxProvider>
    </>
    //     <div className="gangstaverse-info-heading1">Welcome To</div>
    //     <div className="gangstaverse-info-heading2">
    //       Gangsta<span>verse</span>
    //     </div>
    //     <p className="gangstaverse-info-description">
    //       GangstaBet aspires to be a complete ecosystem including the GBET
    //       token, our NFT assets, Crown token, and the Emerald City.
    //     </p>
    //     {/* <button className="gangstaverse-info-button">Action</button> */}
    //   </motion.div>
    // </div>
  );
};

export default GangstaverseInfo;
